import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-date-range-input-modal',
  templateUrl: './date-range-input-modal.component.html',
  styleUrls: ['./date-range-input-modal.component.scss']
})
export class DateRangeInputModalComponent implements Overlayable {

  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @Input('submitCallback') submitCallback?: (dateFrom: string, dateTo: string) => void;
  @Input('cancelCallback') cancelCallback?: () => void;

  @Input("dateFrom") set setDateFrom(dateFrom: string) {
    if(dateFrom) {
      // Differentiate 31.01.2025 and 2025-01-31
      if(dateFrom.indexOf(".") !== -1) {
        const split = dateFrom.split(".");
        this.dateFrom = `${split[2]}-${split[1]}-${split[0]}`;
      } else {
        this.dateFrom = dateFrom;
      }
    }
  }

  @Input("dateTo") set setDateTo(dateTo: string) {
    if(dateTo) {
      if(dateTo.indexOf(".") !== -1) {
        const split = dateTo.split(".");
        this.dateTo = `${split[2]}-${split[1]}-${split[0]}`;
      } else {
        this.dateTo = dateTo;
      }
    }
  }

  dateFrom = "";
  dateTo = "";
  isShowValidation = false;
  onCancelClicked() {
    if(this.cancelCallback) {
      this.cancelCallback();
    } else {
      this.onClosed.emit(true);
    }
  }

  confirm() {
    if(this.dateFrom.length === 0 || this.dateTo.length === 0) {
      this.isShowValidation = true;
    } else {
      if(this.submitCallback) {
        this.submitCallback(this.dateFrom, this.dateTo);
      }
    }

  }

  onOpenDateChanged($event: any) {
    // console.log(this.dateFrom);

  }

  onCloseDateChanged($event: any) {

  }
}
